// extracted by mini-css-extract-plugin
export default {"SetCommissionPop":"SetCommissionPop_SetCommissionPop__-Vv5r","modalBody":"SetCommissionPop_modalBody__mEBz7"};